import {writable} from "svelte/store";
const trainerProgramsCount = writable(0);
export {trainerProgramsCount};
